var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { StoreContext } from '../uistore/Rootstore';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { AppColor, FontSize } from '../const/AppDefaults';
import { ScaleLoader } from 'react-spinners';
const FloatingDatasheet = React.lazy(async () => await import("../UIComponents/FloatingDatasheet"));
import { MdLink } from '@react-icons/all-files/md/MdLink';
import { testIsMobile } from '@@/Util';
let FloatingDatasheetViewer = class FloatingDatasheetViewer extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.floatingDatasheetStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.floatingDatasheetStore.dragging) {
                // lets move this dialog 
                rstore.floatingDatasheetStore.setTop(e.clientY - this.adjusty);
                rstore.floatingDatasheetStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    addLink() {
    }
    render() {
        const rstore = this.context;
        if (!rstore.floatingDatasheetStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-viewer": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.floatingDatasheetStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-viewer")) {
                    rstore.floatingDatasheetStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.floatingDatasheetStore.left + "px", top: rstore.floatingDatasheetStore.top + "px", width: rstore.floatingDatasheetStore.width + "px", height: testIsMobile() ? (window.innerHeight - 200) + "px" : (window.innerHeight - 150) + "px" },
            React.createElement(Flex, { pos: 'relative', "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-viewer": 'colorbox', height: "50px", width: '100%' },
                rstore.floatingDatasheetStore.linkingmode && React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                    React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Add Link', onClick: () => this.addLink() },
                        React.createElement(Icon, { w: '20px', h: '20px', color: AppColor.ActionMenuIcon, className: 'message-option-button', as: MdLink, ml: '1px' }),
                        React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Add Link'))),
                React.createElement(Icon, { pos: 'absolute', right: '5px', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                        rstore.floatingDatasheetStore.setShowDialog(false);
                        rstore.floatingDatasheetStore.reset();
                    }, className: 'message-option-button' })),
            React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                    React.createElement(ScaleLoader, { color: 'green' }),
                    React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising...")) },
                React.createElement(FloatingDatasheet, null)));
    }
};
FloatingDatasheetViewer.contextType = StoreContext;
FloatingDatasheetViewer = __decorate([
    observer
], FloatingDatasheetViewer);
export { FloatingDatasheetViewer };
